'use strict';

module.exports = syr;

function syr () {
  console.error('SYR (symmetric rank 1 operation A := alpha*x*y\' + A) not yet implemented');
}
